module.exports = __webpack_public_path__ + "static/MDQ-4f3ccd2731f13049dacbb43b23a0a6e3.png";